import { NativePlugin } from './plugin';
export class NotificareAssets {
    /**
     * Fetches a list of {@link NotificareAsset} for a specified group.
     *
     * @param {string} group - The name of the group whose assets are to be fetched.
     * @returns {Promise<NotificareAsset[]>} - A promise that resolves to a list of
     * {@link NotificareAsset} belonging to the specified group.
     */
    static async fetch(group) {
        const { result } = await NativePlugin.fetch({ group });
        return result;
    }
}
//# sourceMappingURL=notificare-assets.js.map